module.exports = __webpack_public_path__ + "static/media/barber.c6631a37.jpg";